var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 55,
    viewBox: "0 0 57 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6L34.5 6.5L43.5 16L43 55H8V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63281 6.41398V54.0566C6.63281 54.5627 7.05795 54.9729 7.58244 54.9729H43.6644C44.1884 54.9729 44.6136 54.5627 44.6136 54.0566V15.5763C44.6136 15.5559 44.6034 15.5385 44.6015 15.5185C44.5968 15.4382 44.5803 15.3589 44.553 15.2831C44.5424 15.2536 44.535 15.2253 44.5217 15.1966C44.4755 15.097 44.4114 15.006 44.3316 14.9283L34.8365 5.76637C34.7559 5.68901 34.6613 5.62711 34.5572 5.58296C34.5287 5.57126 34.4998 5.56145 34.47 5.55277C34.3906 5.52635 34.3081 5.5105 34.224 5.50522C34.208 5.50786 34.1892 5.49805 34.1693 5.49805H7.58244C7.05795 5.49805 6.63281 5.90789 6.63281 6.41398ZM41.372 14.66H35.1185V8.62587L41.372 14.66ZM8.53168 7.33028H33.2196V15.5763C33.2196 16.082 33.6448 16.4922 34.1689 16.4922H42.7147V53.1407H8.53168V7.33028Z",
    fill: "#B9BEC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5131 47.6427V49.4749H49.3616C49.8861 49.4749 50.3112 49.0651 50.3112 48.559V0.916307C50.3112 0.410225 49.8861 0 49.3616 0H13.2797C12.7552 0 12.3301 0.410225 12.3301 0.916307V3.66485H14.2293V1.83224H48.412V47.6427H46.5131Z",
    fill: "#B9BEC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 18.3242H37.0188V20.1565H14.2305V18.3242Z",
    fill: "#B9BEC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 12.8262H21.8267V14.6588H14.2305V12.8262Z",
    fill: "#B9BEC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 23.8223H29.4229V25.6549H14.2305V23.8223Z",
    fill: "#B9BEC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3203 23.8223H37.0173V25.6549H31.3203V23.8223Z",
    fill: "#B9BEC8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 29.3184H37.0188V31.151H14.2305V29.3184Z",
    fill: "#B9BEC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 40.3125H37.0188V42.1451H14.2305V40.3125Z",
    fill: "#B9BEC8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7754 34.8164H37.0182V36.6486H22.7754V34.8164Z",
    fill: "#B9BEC8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 34.8164H20.8771V36.6486H14.2305V34.8164Z",
    fill: "#B9BEC8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 45.8105H18.0286V47.6428H14.2305V45.8105Z",
    fill: "#B9BEC8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9277 45.8105H37.0191V47.6428H19.9277V45.8105Z",
    fill: "#B9BEC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.92196cb8e0976d7fe0341364cfe6573e.svg";
export { ForwardRef as ReactComponent };